import React, { useEffect, useState } from 'react';
import { PeriodoDescripciones } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorPeriodos = (props:any) =>{
  let {data,onChange,getText,valueOfSelected,disabledData} = props;
  let [options, setOptions] = useState<any>(undefined);

  useEffect(()=>{
    if(data)
    {setOptions(getOptions())}
  },[data])

  useEffect(()=>{
    if(disabledData!==undefined){
      if(options && options.length>0 && (options.length>disabledData.length)){
        valueOfSelected ? change(valueOfSelected) : change(options[0].value)
      }
    }else{
      if(options && options.length>0){
        valueOfSelected ? change(valueOfSelected) : change(options[0].value)
      }
    }
    
  },[options])

  const getOptions = () =>{
    if(disabledData && disabledData.length>0)
    {
      return data.map((p: PeriodoDescripciones)=> { 
        return { value: p.idTipoPeriodo, inputDisplay: p.tipoPeriodo, disabled: disabledData.includes(p.idTipoPeriodo) } 
      })
    }else{
      return data.map((p: PeriodoDescripciones)=> { return { value: p.idTipoPeriodo, inputDisplay: p.tipoPeriodo } })
    }
    
  }

  const change = (value:any) =>{
    if(getText)
    {
      const itemSel = data.find((e:PeriodoDescripciones)=> e.idTipoPeriodo===value);
      onChange(itemSel)
    }else{
      onChange(value)
    }
  }
  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectPeriodo"/>
  )
}

export default SelectorPeriodos